export default __webpack_public_path__ + "static/media/fadeBgMenu.c410e00d.png";